var _desc, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilters(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created using Figma")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "filters_svg__filters_svg__Canvas",
    transform: "translate(-450 -911)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "filters_svg__filters_svg__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "filters_svg__filters_svg__Shape"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#filters_svg__filters_svg__path0_fill",
    transform: "translate(450 922.2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "filters_svg__filters_svg__Shape"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#filters_svg__filters_svg__path1_fill",
    transform: "translate(457.755 922.2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "filters_svg__filters_svg__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "filters_svg__filters_svg__Shape"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#filters_svg__filters_svg__path2_fill",
    transform: "translate(462.711 917.533)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "filters_svg__filters_svg__Shape"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#filters_svg__filters_svg__path3_fill",
    transform: "translate(450.267 917.533)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "filters_svg__filters_svg__Shape"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#filters_svg__filters_svg__path4_fill",
    transform: "translate(458.267 915.667)",
    fill: "#8D8D8D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "filters_svg__filters_svg__Shape"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#filters_svg__filters_svg__path5_fill",
    transform: "translate(452.472 920.333)",
    fill: "#8D8D8D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "filters_svg__filters_svg__Shape"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#filters_svg__filters_svg__path6_fill",
    transform: "translate(450 912.867)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "filters_svg__filters_svg__Shape"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#filters_svg__filters_svg__path7_fill",
    transform: "translate(456.874 912.867)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "filters_svg__filters_svg__Shape"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#filters_svg__filters_svg__path8_fill",
    transform: "translate(452.472 911)",
    fill: "#8D8D8D"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "filters_svg__filters_svg__path0_fill",
    fillRule: "evenodd",
    d: "M 0.352169 0.735179L 1.51873 0.735179C 1.71683 0.735179 1.8709 0.574359 1.8709 0.36759C 1.8709 0.160821 1.71683 0 1.51873 0L 0.352169 0C 0.154074 0 0 0.160821 0 0.36759C -7.81973e-16 0.574359 0.154074 0.735179 0.352169 0.735179Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "filters_svg__filters_svg__path1_fill",
    fillRule: "evenodd",
    d: "M 0.215101 0.735179L 6.72191 0.735179C 6.8429 0.735179 6.93701 0.574359 6.93701 0.36759C 6.93701 0.160821 6.8429 0 6.72191 0L 0.215101 0C 0.0941067 0 0 0.160821 0 0.36759C 9.5524e-16 0.574359 0.0941067 0.735179 0.215101 0.735179Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "filters_svg__filters_svg__path2_fill",
    fillRule: "evenodd",
    d: "M 1.60761 0.735179L 0.37278 0.735179C 0.163091 0.735179 0 0.574359 0 0.36759C 0 0.160821 0.163091 0 0.37278 0L 1.60761 0C 1.8173 0 1.98039 0.160821 1.98039 0.36759C 1.98039 0.551385 1.8173 0.735179 1.60761 0.735179Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "filters_svg__filters_svg__path3_fill",
    fillRule: "evenodd",
    d: "M 7.49902 0.735179L 0.24045 0.735179C 0.105197 0.735179 0 0.574359 0 0.36759C 0 0.160821 0.105197 0 0.24045 0L 7.51405 0C 7.6493 0 7.7545 0.160821 7.7545 0.36759C 7.73947 0.551385 7.63427 0.735179 7.49902 0.735179Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "filters_svg__filters_svg__path4_fill",
    fillRule: "evenodd",
    d: "M 2.04698 4.27323C 0.902434 4.27323 0 3.30831 0 2.13662C 0 0.941949 0.924445 0 2.04698 0C 3.19153 0 4.09397 0.964923 4.09397 2.13662C 4.09397 3.30831 3.16952 4.27323 2.04698 4.27323Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "filters_svg__filters_svg__path5_fill",
    fillRule: "evenodd",
    d: "M 0 2.13662C 0 0.941949 0.924445 0 2.04698 0C 3.19153 0 4.09397 0.964923 4.09397 2.13662C 4.09397 3.33128 3.16952 4.27323 2.04698 4.27323C 0.924445 4.27323 0 3.30831 0 2.13662Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "filters_svg__filters_svg__path6_fill",
    fillRule: "evenodd",
    d: "M 0.352169 0.735179L 1.51873 0.735179C 1.71683 0.735179 1.8709 0.574359 1.8709 0.36759C 1.8709 0.160821 1.71683 0 1.51873 0L 0.352169 0C 0.154074 0 0 0.160821 0 0.36759C 0 0.574359 0.154074 0.735179 0.352169 0.735179Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "filters_svg__filters_svg__path7_fill",
    fillRule: "evenodd",
    d: "M 0.24045 0.735179L 7.51405 0.735179C 7.6493 0.735179 7.7545 0.574359 7.7545 0.36759C 7.7545 0.160821 7.6493 0 7.51405 0L 0.24045 0C 0.105197 0 0 0.160821 0 0.36759C 0 0.574359 0.105197 0.735179 0.24045 0.735179Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "filters_svg__filters_svg__path8_fill",
    fillRule: "evenodd",
    d: "M 0 2.13662C 0 0.941949 0.924445 0 2.04698 0C 3.19153 0 4.09397 0.964923 4.09397 2.13662C 4.09397 3.33128 3.16952 4.27323 2.04698 4.27323C 0.924445 4.29621 0 3.33128 0 2.13662Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilters);
export default __webpack_public_path__ + "static/media/filters.2404dcedfd2c0b0dff3210d15fe15b66.svg";
export { ForwardRef as ReactComponent };